import Cookies from 'js-cookie';
import { COOKIE_NAME_PRERENDER_DATA } from 'next/dist/server/api-utils';
import type { EventOptions, BaseEvent } from '@amplitude/analytics-types';

export const logEvent = (
  event: BaseEvent | string,
  data?: Record<string, unknown> | undefined,
  eventOptions?: EventOptions,
) => {
  /**
   * If Preview mode or SDK doesn't exist don't log amplitude events
   */
  if (Cookies.get(COOKIE_NAME_PRERENDER_DATA) || typeof window === 'undefined' || !window.amplitude) {
    return;
  }

  window.amplitude.track(event, data, eventOptions);
};

export const setUserId = (userId?: string) => {
  /**
   * If amplitude SDK doesn't exist
   */
  if (typeof window === 'undefined' || !window.amplitude) {
    return;
  }

  window.amplitude.setUserId(userId);
};
